module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-900.22ac8fd.woff";